import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api/api"; 
import { CheckBadgeIcon, ExclamationTriangleIcon, ArrowLeftIcon, DocumentArrowDownIcon } from "@heroicons/react/24/outline";

export default function CertificateValidation() {
  const { hash } = useParams();
  const [loading, setLoading] = useState(true);
  const [cert, setCert] = useState(null);
  const [error, setError] = useState(null);

  // URL Base do seu backend para abrir o PDF
  const BASE_URL = "https://imagensdaface.com.br";

  useEffect(() => {
    async function validate() {
      try {
        const response = await api.get(`/certificates/validate/${hash}`);
        setCert(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || "Certificado não encontrado em nossa base de dados.");
      } finally {
        setLoading(false);
      }
    }
    validate();
  }, [hash]);

  if (loading) return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        
        {/* Card Principal */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-200">
          
          {/* Header do Card */}
          <div className={`${error ? 'bg-red-600' : 'bg-indigo-900'} p-8 text-center text-white`}>
            {error ? (
              <ExclamationTriangleIcon className="h-16 w-16 mx-auto mb-4 text-red-200" />
            ) : (
              <CheckBadgeIcon className="h-16 w-16 mx-auto mb-4 text-emerald-400" />
            )}
            <h1 className="text-3xl font-bold tracking-tight">
              {error ? "Falha na Validação" : "Certificado Verificado"}
            </h1>
            <p className="mt-2 text-indigo-100 opacity-90">
              Sistema Oficial de Autenticidade - Imagens da Face
            </p>
          </div>

          <div className="p-8 md:p-12">
            {error ? (
              <div className="text-center">
                <p className="text-xl text-slate-600 mb-8">{error}</p>
                <Link to="/" className="inline-flex items-center text-indigo-600 font-semibold hover:text-indigo-800">
                  <ArrowLeftIcon className="h-5 w-5 mr-2" /> Voltar para o início
                </Link>
              </div>
            ) : (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
                  <div className="space-y-1">
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Aluno</label>
                    <p className="text-xl font-semibold text-slate-800">{cert.student}</p>
                  </div>
                  <div className="space-y-1">
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Data de Emissão</label>
                    <p className="text-xl font-semibold text-slate-800">
                      {new Date(cert.issue_date).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                  <div className="md:col-span-2 space-y-1 border-t pt-6">
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-400">Curso Concluído</label>
                    <p className="text-2xl font-serif italic text-indigo-900">{cert.course}</p>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-center gap-4 border-t border-slate-100 pt-8">
                  {/* BOTÃO CORRIGIDO: Abre o PDF em nova aba */}
                  <a 
                    href={`${BASE_URL}${cert.url}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-full md:w-auto px-8 py-4 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 transition-all shadow-lg hover:shadow-indigo-200 active:scale-95"
                  >
                    <DocumentArrowDownIcon className="h-6 w-6 mr-2" />
                    Visualizar Certificado (PDF)
                  </a>
                  
                  <Link 
                    to="/" 
                    className="flex items-center justify-center w-full md:w-auto px-8 py-4 bg-slate-100 text-slate-600 font-semibold rounded-xl hover:bg-slate-200 transition-all"
                  >
                    Voltar ao Site
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Rodapé de Segurança */}
        <p className="text-center mt-8 text-slate-400 text-sm">
          Este documento é protegido digitalmente. O código de validação único garante que as informações aqui apresentadas conferem com nossos registros acadêmicos.
        </p>
      </div>
    </div>
  );
}